// extracted by mini-css-extract-plugin
export default {"individual-business-containeer":"IndividualBusinessPricing_individual-business-containeer__1o0xO","price-plan-grid":"IndividualBusinessPricing_price-plan-grid__N9mBd"};